import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=75fc6d92&scoped=true&"
import script from "./UsersCard.vue?vue&type=script&lang=ts&"
export * from "./UsersCard.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCard.vue?vue&type=style&index=0&id=75fc6d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc6d92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
